'use client';
import { X } from 'lucide-react';
import styles from './search-error.module.less';

export default function SearchError({
  onClose,
  onTryAgainClick,
}: {
  onClose?: () => void;
  onTryAgainClick?: () => void;
}) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Close Button */}
        <button
          onClick={handleClose}
          className={styles.closeButton}
        >
          <X size={24} />
        </button>

        {/* Content */}
        <div className={styles.content}>
          <h2 className={styles.title}>
            Invalid User
          </h2>
          <p className={styles.description}>
            The username you entered couldn't be found. Please enter a valid @handle or profile URL, and try again.
          </p>

          {/* Try Again Button */}
          <button
            onClick={onTryAgainClick}
            className={styles.tryAgainButton}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}
